
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/recenze",
      function () {
        return require("private-next-pages/[region]/[resort]/recenze.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/recenze"])
      });
    }
  